// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__gQdv7","text":"TextArea_text__o8emY"};